(function () {
  if (window.__prWlBound) return;
  window.__prWlBound = true;

  var C = window.PR_WL || {};
  var PENDING_KEY = "pr_wl_pending";
  var CACHE_KEY = "pr_wl_cache";
  var PENDING_TTL_MS = 15 * 60 * 1000;
  var loggedIn = !!C.customerId;
  var canSave = loggedIn && !!C.sig && !!C.endpoint;
  var items = normalize(C.items);
  var productCache = {};
  var toastTimer = null;

  (function preferNewerCache() {
    if (!loggedIn) return;
    try {
      var cached = JSON.parse(sessionStorage.getItem(CACHE_KEY) || "null");
      if (cached && String(cached.cid) === String(C.customerId) && cached.at > Number(C.ts || 0) * 1000) {
        items = normalize(cached.items);
      }
    } catch (e) {}
  })();

  function normalize(list) {
    if (!Array.isArray(list)) return [];
    return list
      .map(function (it) {
        return { v: String(it.v || ""), p: String(it.p || ""), h: String(it.h || ""), t: it.t || 0 };
      })
      .filter(function (it) {
        return it.v && it.p && it.h;
      });
  }

  function remember() {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ cid: C.customerId, at: Date.now(), items: items }));
    } catch (e) {}
  }

  function hasVariant(v) {
    return items.some(function (it) { return it.v === String(v); });
  }

  function hasProduct(p) {
    return items.some(function (it) { return it.p === String(p); });
  }

  function rootUrl() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  }

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function formatMoney(cents) {
    var format = C.moneyFormat || "₹{{amount_no_decimals}}";
    function group(n, decimals, thousands, decimal) {
      var fixed = (n / 100).toFixed(decimals).split(".");
      var whole = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return whole + (fixed[1] ? decimal + fixed[1] : "");
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case "amount_no_decimals": return group(cents, 0, ",", ".");
        case "amount_with_comma_separator": return group(cents, 2, ".", ",");
        case "amount_no_decimals_with_comma_separator": return group(cents, 0, ".", ",");
        default: return group(cents, 2, ",", ".");
      }
    });
  }

  /* ---------- painting ---------- */

  function pdpVariant(btn) {
    var bar = btn.closest("[data-sticky-atc]") || document.querySelector("[data-sticky-atc]");
    return (bar && bar.dataset.variantId) || btn.dataset.variantId;
  }

  function paint() {
    document.querySelectorAll("[data-pr-wl-heart]").forEach(function (btn) {
      var on = btn.dataset.context === "pdp" ? hasVariant(pdpVariant(btn)) : hasProduct(btn.dataset.productId);
      btn.classList.toggle("is-active", on);
      btn.setAttribute("aria-pressed", on ? "true" : "false");
    });
    var n = items.length;
    var badge = n > 99 ? "99+" : String(n);
    var label = n ? "(" + n + ")" : "";
    document.querySelectorAll("[data-pr-wl-count]").forEach(function (el) {
      if (el.textContent !== badge) el.textContent = badge;
      if (el.hidden !== (n === 0)) el.hidden = n === 0;
    });
    document.querySelectorAll("[data-pr-wl-count-text]").forEach(function (el) {
      if (el.textContent !== label) el.textContent = label;
    });
  }

  var paintQueued = false;
  function schedulePaint() {
    if (paintQueued) return;
    paintQueued = true;
    requestAnimationFrame(function () {
      paintQueued = false;
      paint();
    });
  }

  /* ---------- toast ---------- */

  function toast(text, withLink) {
    var el = document.querySelector("[data-pr-wl-toast]");
    if (!el) return;
    el.querySelector("[data-pr-wl-toast-text]").textContent = text;
    var link = el.querySelector("[data-pr-wl-toast-link]");
    if (link) link.hidden = !withLink;
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add("is-visible"); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove("is-visible");
      setTimeout(function () { el.hidden = true; }, 250);
    }, 3200);
  }

  /* ---------- saving ---------- */

  function save(change) {
    if (!canSave) return Promise.reject(new Error("not_ready"));
    return fetch(C.endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        customerId: C.customerId,
        ts: Number(C.ts),
        sig: C.sig,
        add: change.add || [],
        removeVariants: change.removeVariants || [],
        removeProducts: change.removeProducts || [],
      }),
    })
      .then(function (res) {
        return res.json().catch(function () { return { ok: false }; });
      })
      .then(function (data) {
        if (!data || !data.ok) throw new Error((data && data.message) || "Could not update your wishlist. Try again.");
        items = normalize(data.items);
        remember();
        paint();
        return items;
      });
  }

  function applyLocally(change) {
    var before = items.slice();
    var rv = (change.removeVariants || []).map(String);
    var rp = (change.removeProducts || []).map(String);
    items = items.filter(function (it) { return rv.indexOf(it.v) < 0 && rp.indexOf(it.p) < 0; });
    (change.add || []).forEach(function (a) {
      items = items.filter(function (it) { return it.v !== String(a.v); });
      items.unshift({ v: String(a.v), p: String(a.p), h: a.h, t: Math.floor(Date.now() / 1000) });
    });
    paint();
    return before;
  }

  function change(delta) {
    var before = applyLocally(delta);
    return save(delta).catch(function (err) {
      items = before;
      paint();
      toast(err && err.message && err.message !== "not_ready" ? err.message : "Could not update your wishlist. Try again.");
      throw err;
    });
  }

  function track(name, entry, extra) {
    if (!window.prTrack) return;
    var data = { product_id: entry && entry.p, variant_id: entry && entry.v, handle: entry && entry.h };
    for (var k in extra || {}) data[k] = extra[k];
    window.prTrack(name, data);
  }

  function addItem(entry, source) {
    track("pr_wishlist_add", entry, { source: source || "" });
    return change({ add: [entry] }).then(function () {
      toast("Saved to wishlist", true);
      renderAllLists();
    });
  }

  /* ---------- login hand-off ---------- */

  function requireLogin(pending) {
    try {
      localStorage.setItem(PENDING_KEY, JSON.stringify(Object.assign({ at: Date.now(), url: location.href }, pending)));
    } catch (e) {}
    if (window.PaintroadAuth && typeof window.PaintroadAuth.open === "function") {
      window.PaintroadAuth.open({ intent: "wishlist", afterUrl: location.pathname + location.search });
      return;
    }
    location.href = rootUrl() + "account/login?return_url=" + encodeURIComponent(location.pathname + location.search);
  }

  document.addEventListener("pr-auth:success", function (event) {
    if (event.detail && event.detail.intent === "wishlist") location.reload();
  });

  function takePending() {
    var raw = null;
    try {
      raw = JSON.parse(localStorage.getItem(PENDING_KEY) || "null");
      localStorage.removeItem(PENDING_KEY);
    } catch (e) {}
    if (!raw || !raw.at || Date.now() - raw.at > PENDING_TTL_MS) return null;
    return raw;
  }

  function runPending() {
    if (!loggedIn) return;
    var pending = takePending();
    if (!pending) return;
    if (pending.type === "open") {
      if (sheetMode()) openListSheet();
      else location.href = C.wishlistUrl;
      return;
    }
    if (!canSave) return;
    var entry = { v: pending.v, p: pending.p, h: pending.h };
    if (pending.type === "add") {
      if (hasVariant(entry.v)) toast("Saved to wishlist", true);
      else addItem(entry);
      return;
    }
    if (pending.type === "move") {
      change({ add: [entry] }).then(function () {
        var line = cartLineForVariant(entry.v);
        if (line) removeCartLine(line);
        toast("Moved to wishlist", true);
      });
    }
  }

  /* ---------- hearts ---------- */

  function onHeart(btn) {
    var p = btn.dataset.productId;
    var h = btn.dataset.handle;
    var v = btn.dataset.context === "pdp" ? pdpVariant(btn) : btn.dataset.variantId;
    var source = btn.dataset.context || "card";
    if (!loggedIn) {
      track("pr_wishlist_login_required", { v: v, p: p, h: h }, { source: source });
      requireLogin({ type: "add", v: v, p: p, h: h });
      return;
    }
    var removed = function () {
      toast("Removed from wishlist");
      renderAllLists();
    };
    if (btn.dataset.context === "pdp") {
      if (hasVariant(v)) {
        track("pr_wishlist_remove", { v: v, p: p, h: h }, { source: source });
        change({ removeVariants: [v] }).then(removed);
      } else addItem({ v: v, p: p, h: h }, source);
      return;
    }
    if (hasProduct(p)) {
      track("pr_wishlist_remove", { v: v, p: p, h: h }, { source: source });
      change({ removeProducts: [p] }).then(removed);
    } else addItem({ v: v, p: p, h: h }, source);
  }

  /* ---------- cart helpers ---------- */

  function cartItemsEl() {
    return document.querySelector("cart-items");
  }

  function cartLineForVariant(v) {
    var input = document.querySelector('cart-items input[data-quantity-variant-id="' + v + '"]');
    return input ? input.dataset.index : null;
  }

  function removeCartLine(line) {
    var el = cartItemsEl();
    if (el && typeof el.updateQuantity === "function") {
      el.updateQuantity(String(line), 0, { currentTarget: null }, null);
      return;
    }
    fetch(rootUrl() + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: Number(line), quantity: 0 }),
    }).then(function () { location.reload(); });
  }

  function refreshCartUi(cart) {
    if (C.isCart) {
      var itemsWrap = document.getElementById("main-cart-items");
      var footer = document.getElementById("main-cart-footer");
      var el = cartItemsEl();
      if (!itemsWrap || !footer || !el || el.classList.contains("is-empty")) {
        location.reload();
        return;
      }
      var ids = [itemsWrap.dataset.id, footer.dataset.id, "cart-icon-bubble"];
      fetch(location.pathname + "?sections=" + ids.join(","))
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          [[itemsWrap, ids[0], ".js-contents"], [footer, ids[1], ".js-contents"]].forEach(function (row) {
            var doc = new DOMParser().parseFromString(sections[row[1]] || "", "text/html");
            var src = doc.querySelector(row[2]);
            var dest = row[0].querySelector(row[2]);
            if (src && dest) dest.innerHTML = src.innerHTML;
          });
          var bubble = document.getElementById("cart-icon-bubble");
          var bdoc = new DOMParser().parseFromString(sections["cart-icon-bubble"] || "", "text/html");
          var bsrc = bdoc.querySelector(".shopify-section");
          if (bubble && bsrc) bubble.innerHTML = bsrc.innerHTML;
        })
        .catch(function () { location.reload(); });
      return;
    }
    try {
      if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "pr-wishlist", cartData: cart });
      }
    } catch (e) {}
    if (typeof window.syncCartIconBubble === "function") {
      window.syncCartIconBubble();
      return;
    }
    var bubbleEl = document.getElementById("cart-icon-bubble");
    if (!bubbleEl) return;
    fetch(rootUrl() + "?sections=cart-icon-bubble")
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var doc = new DOMParser().parseFromString(data["cart-icon-bubble"] || "", "text/html");
        var src = doc.querySelector(".shopify-section");
        if (src) bubbleEl.innerHTML = src.innerHTML;
      })
      .catch(function () {});
  }

  function addToCart(v) {
    return fetch(rootUrl() + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: JSON.stringify({ items: [{ id: Number(v), quantity: 1 }] }),
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        if (!res.ok) throw new Error((res.data && (res.data.description || res.data.message)) || "Could not add to cart.");
        return fetch(rootUrl() + "cart.js").then(function (r) { return r.json(); });
      });
  }

  /* ---------- list (account page + cart sheet) ---------- */

  function loadProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch(rootUrl() + "products/" + encodeURIComponent(handle) + ".js", {
        headers: { Accept: "application/json" },
      }).then(function (r) {
        return r.ok ? r.json() : null;
      }).catch(function () {
        return null;
      });
    }
    return productCache[handle];
  }

  function sizedImage(src, width) {
    if (!src) return "";
    if (src.indexOf("//") === 0) src = "https:" + src;
    return src + (src.indexOf("?") > -1 ? "&" : "?") + "width=" + width;
  }

  function optionRows(product, variant) {
    var names = (product.options || []).map(function (o) { return typeof o === "string" ? o : o.name; });
    if (names.length === 1 && /^title$/i.test(names[0])) return "";
    var order = ["size", "material", "frame"];
    var rows = names.map(function (name, i) { return { name: name, value: variant.options[i], key: String(name).toLowerCase() }; });
    rows.sort(function (a, b) {
      var ia = order.indexOf(a.key);
      var ib = order.indexOf(b.key);
      return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
    });
    return rows
      .filter(function (r) { return r.value; })
      .map(function (r) { return "<div><dt>" + esc(r.name) + ":</dt><dd>" + esc(r.value) + "</dd></div>"; })
      .join("");
  }

  function itemHtml(entry, product, variant) {
    var festive = Math.floor((variant.price * (C.festivePct || 100)) / 100);
    var strike = variant.compare_at_price > variant.price ? variant.compare_at_price : variant.price;
    var off = strike > festive ? Math.round(((strike - festive) / strike) * 100) : 0;
    var img = (variant.featured_image && variant.featured_image.src) || product.featured_image;
    var url = rootUrl() + "products/" + encodeURIComponent(product.handle) + "?variant=" + variant.id;
    return (
      '<article class="pr-wl-item" data-pr-wl-item data-variant-id="' + esc(entry.v) + '">' +
      '<a class="pr-wl-item__media" href="' + url + '">' +
      (img ? '<img src="' + esc(sizedImage(img, 260)) + '" alt="' + esc(product.title) + '" loading="lazy">' : "") +
      "</a>" +
      '<div class="pr-wl-item__info">' +
      '<a class="pr-wl-item__title" href="' + url + '">' + esc(product.title) + "</a>" +
      '<dl class="pr-wl-item__opts">' + optionRows(product, variant) + "</dl>" +
      '<div class="pr-wl-item__prices"><b>' + formatMoney(festive) + "</b>" +
      (strike > festive ? "<s>" + formatMoney(strike) + "</s>" : "") +
      (off ? '<span class="pr-wl-item__off">' + off + "% off</span>" : "") +
      "</div>" +
      (variant.available
        ? '<button type="button" class="pr-wl-btn pr-wl-btn--outline" data-pr-wl-tocart><span>Move to cart</span></button>'
        : '<button type="button" class="pr-wl-btn pr-wl-btn--outline" disabled><span>Sold out</span></button>') +
      "</div>" +
      '<button type="button" class="pr-wl-item__remove" data-pr-wl-remove aria-label="Remove ' + esc(product.title) + ' from wishlist">' +
      '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
      "</button>" +
      "</article>"
    );
  }

  function setEmpty(list, empty) {
    var page = list.closest(".pra__main");
    var emptyEl = page && page.querySelector("[data-pr-wl-empty]");
    if (emptyEl) {
      emptyEl.hidden = !empty;
      list.hidden = empty;
      return;
    }
    if (empty) {
      list.innerHTML =
        '<div class="pr-wl-empty"><p><b>Your wishlist is empty.</b></p><p>Tap the heart on any artwork to save it here.</p></div>';
    }
  }

  function renderList(list) {
    if (!list) return;
    if (!loggedIn) {
      list.innerHTML = '<div class="pr-wl-empty"><p>Log in to see your wishlist.</p></div>';
      return;
    }
    if (!items.length) {
      setEmpty(list, true);
      return;
    }
    setEmpty(list, false);
    list.innerHTML = items
      .map(function () { return '<div class="pr-wl-item pr-wl-item--skeleton" aria-hidden="true"><span></span><span></span></div>'; })
      .join("");
    var snapshot = items.slice();
    Promise.all(snapshot.map(function (it) { return loadProduct(it.h); })).then(function (products) {
      var stale = [];
      var html = snapshot
        .map(function (it, i) {
          var product = products[i];
          var variant = product && (product.variants || []).filter(function (vr) { return String(vr.id) === it.v; })[0];
          if (!product || !variant) {
            stale.push(it.v);
            return "";
          }
          return itemHtml(it, product, variant);
        })
        .join("");
      list.innerHTML = html;
      if (stale.length) save({ removeVariants: stale }).catch(function () {});
      if (!html) setEmpty(list, true);
    });
  }

  function renderAllLists() {
    document.querySelectorAll("[data-pr-wl-list]").forEach(function (list) {
      if (list.closest("[data-pr-wl-sheet]") && list.closest("[data-pr-wl-sheet]").hidden) return;
      renderList(list);
    });
  }

  function removeRow(row) {
    var list = row.closest("[data-pr-wl-list]");
    row.remove();
    if (list && !list.querySelector("[data-pr-wl-item]")) setEmpty(list, true);
  }

  function onRemove(btn) {
    var row = btn.closest("[data-pr-wl-item]");
    var v = row.dataset.variantId;
    row.classList.add("is-busy");
    track("pr_wishlist_remove", { v: v, p: row.dataset.productId, h: row.dataset.handle }, { source: "wishlist_list" });
    change({ removeVariants: [v] })
      .then(function () {
        removeRow(row);
        toast("Removed from wishlist");
      })
      .catch(function () { row.classList.remove("is-busy"); });
  }

  function onMoveToCart(btn) {
    var row = btn.closest("[data-pr-wl-item]");
    var v = row.dataset.variantId;
    var label = btn.querySelector("span");
    btn.disabled = true;
    if (label) label.textContent = "Moving…";
    track("pr_wishlist_move_to_cart", { v: v, p: row.dataset.productId, h: row.dataset.handle });
    addToCart(v)
      .then(function (cart) {
        return change({ removeVariants: [v] }).catch(function () {}).then(function () {
          removeRow(row);
          toast("Moved to cart");
          refreshCartUi(cart);
        });
      })
      .catch(function (err) {
        btn.disabled = false;
        if (label) label.textContent = "Move to cart";
        toast((err && err.message) || "Could not add to cart.");
      });
  }

  /* ---------- sheets (cart page) ---------- */

  function sheet(name) {
    return document.querySelector('[data-pr-wl-sheet="' + name + '"]');
  }

  function openSheet(el) {
    if (!el) return;
    el.hidden = false;
    document.documentElement.classList.add("pr-wl-lock");
    var body = el.querySelector("[data-pr-wl-sheet-body]");
    if (body) body.scrollTop = 0;
    el.classList.remove("is-full");
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { el.classList.add("is-open"); });
    });
  }

  function closeSheet(el) {
    if (!el || el.hidden) return;
    el.classList.remove("is-open");
    setTimeout(function () {
      el.hidden = true;
      if (!document.querySelector("[data-pr-wl-sheet]:not([hidden])")) document.documentElement.classList.remove("pr-wl-lock");
    }, 280);
  }

  function sheetMode() {
    return C.isCart && window.matchMedia("(max-width: 989px)").matches;
  }

  function openListSheet() {
    var el = sheet("list");
    if (!el || !sheetMode()) {
      location.href = C.wishlistUrl;
      return;
    }
    openSheet(el);
    if (window.prTrack) window.prTrack("pr_wishlist_view", { surface: "cart_sheet", count: items.length });
    renderList(el.querySelector("[data-pr-wl-list]"));
  }

  var confirmTarget = null;

  function lineTarget(moveBtn) {
    return {
      line: moveBtn.dataset.line,
      v: moveBtn.dataset.variantId,
      p: moveBtn.dataset.productId,
      h: moveBtn.dataset.handle,
    };
  }

  function moveLineToWishlist(target, btn, el) {
    if (!loggedIn) {
      track("pr_wishlist_login_required", target, { source: "cart_move" });
      requireLogin({ type: "move", v: target.v, p: target.p, h: target.h });
      return;
    }
    if (btn.disabled) return;
    btn.disabled = true;
    track("pr_cart_move_to_wishlist", target, { source: el ? "confirm_sheet" : "cart_link" });
    change({ add: [{ v: target.v, p: target.p, h: target.h }] })
      .then(function () {
        if (el) closeSheet(el);
        removeCartLine(target.line);
        toast("Moved to wishlist", true);
      })
      .catch(function () {})
      .then(function () { btn.disabled = false; });
  }

  function onMove(moveBtn) {
    moveLineToWishlist(lineTarget(moveBtn), moveBtn, null);
  }

  function openConfirm(moveBtn) {
    var el = sheet("confirm");
    if (!el || !moveBtn) return;
    var row = moveBtn.closest(".cart-item");
    confirmTarget = lineTarget(moveBtn);
    var img = row && row.querySelector(".cart-item__image-container img");
    var name = row && row.querySelector(".cart-item__name");
    var opts = row && row.querySelector(".cart-item__details dl");
    el.querySelector("[data-pr-wl-confirm-item]").innerHTML =
      (img ? '<img src="' + esc(img.currentSrc || img.src) + '" alt="">' : "") +
      "<div><b>" + esc(name ? name.textContent.trim() : "") + "</b>" +
      (opts ? '<dl class="pr-wl-item__opts">' + opts.innerHTML + "</dl>" : "") +
      "</div>";
    openSheet(el);
  }

  function onConfirm(action, btn) {
    var target = confirmTarget;
    var el = sheet("confirm");
    if (!target) return closeSheet(el);
    if (action === "remove") {
      closeSheet(el);
      removeCartLine(target.line);
      return;
    }
    moveLineToWishlist(target, btn, el);
  }

  /* ---------- events ---------- */

  document.addEventListener(
    "click",
    function (event) {
      var t = event.target;
      if (!t.closest) return;

      var heart = t.closest("[data-pr-wl-heart]");
      if (heart) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        onHeart(heart);
        return;
      }

      // The cart row's stretched product link sits over this button; stop it navigating.
      var move = t.closest("[data-pr-wl-move]");
      if (move) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        onMove(move);
        return;
      }

      if (sheetMode() && t.closest("[data-pr-wl-toast-link]")) {
        event.preventDefault();
        openListSheet();
        return;
      }

      var header = t.closest("[data-pr-wl-header]");
      if (header) {
        if (!loggedIn) {
          event.preventDefault();
          requireLogin({ type: "open" });
        } else if (header.hasAttribute("data-pr-wl-sheet-open") && sheetMode()) {
          event.preventDefault();
          openListSheet();
        }
        return;
      }

      var minus = t.closest('cart-items quantity-input button[name="minus"]');
      if (minus) {
        var input = minus.parentElement.querySelector("input");
        var row = minus.closest(".cart-item");
        var moveBtn = row && row.querySelector("[data-pr-wl-move]");
        if (input && moveBtn && parseInt(input.value, 10) <= 1) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          openConfirm(moveBtn);
        }
      }
    },
    true
  );

  document.addEventListener("click", function (event) {
    var t = event.target;
    if (!t.closest) return;
    var el;
    if ((el = t.closest("[data-pr-wl-confirm]"))) return onConfirm(el.getAttribute("data-pr-wl-confirm"), el);
    if ((el = t.closest("[data-pr-wl-sheet-close]"))) return closeSheet(el.closest("[data-pr-wl-sheet]"));
    if ((el = t.closest("[data-pr-wl-remove]"))) return onRemove(el);
    if ((el = t.closest("[data-pr-wl-tocart]"))) return onMoveToCart(el);
  });

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;
    document.querySelectorAll("[data-pr-wl-sheet]:not([hidden])").forEach(closeSheet);
  });

  document.addEventListener(
    "scroll",
    function (event) {
      var body = event.target;
      if (!body || !body.matches || !body.matches("[data-pr-wl-sheet-body]")) return;
      var el = body.closest("[data-pr-wl-sheet]");
      if (el && body.scrollTop > 8) el.classList.add("is-full");
    },
    true
  );

  function init() {
    paint();
    if (window.prTrack && document.querySelector("[data-pr-wl-list]:not([data-pr-wl-sheet] [data-pr-wl-list])")) {
      window.prTrack("pr_wishlist_view", { surface: "account_page", count: items.length });
    }
    renderAllLists();
    runPending();
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === "attributes" || m.addedNodes.length) {
          schedulePaint();
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["data-variant-id"] });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
